module.exports = " <div class=cloth-checkbox :class=\"{ 'checked': selections.indexOf(cloth) !== -1 }\"> <span class=\"serif program-number cloth-{{ cloth }}\">{{ cloth }}</span> <input type=checkbox v-model=selections :value=cloth /> <span class=\"right empty\"></span> <span class=\"right checked\"> <img v-icon.literal=checkmark.svg alt=Checkmark /> </span> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./site/sites/all/themes/custom/abr_theme/js/gambling-calculator/components/ClothCheckbox.vue
 ** module id = 109
 ** module chunks = 0
 **/